import { useEffect } from "react";
import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "du-csas-round-2-schedule-revised-2026",
  title:
    "DU CSAS 2026 Round 2 Revised Schedule: Complete Allotment Guide",
  description:
    "Delhi University revised the CSAS 2026 Round 2 schedule and allotment deadlines. Read the updated, consolidated CSAS Round 2 allotment guide for complete dates and procedures.",
  pubDate: "2026-07-26",
  updatedDate: "2026-07-26",
  authorSlug: "uday-kumar",
  category: "news",
  tags: ["DU admissions", "CSAS 2026", "seat allotment", "UG admission"],
  readMinutes: 2,
  heroEyebrow: "News · DU Admissions (Consolidated)",
};

export function Body() {
  useEffect(() => {
    // Client-side redirect to consolidated master post
    if (typeof window !== "undefined") {
      window.location.replace("/blog/du-csas-round-2-allotment-2026");
    }
  }, []);

  return (
    <div className="my-6 border border-ink bg-card p-6">
      <h2 className="text-xl font-semibold mb-2">Notice: Content Consolidated</h2>
      <p className="text-pencil leading-relaxed mb-4">
        This article has been merged into our comprehensive, master guide:{" "}
        <a
          href="/blog/du-csas-round-2-allotment-2026"
          className="font-semibold underline text-grade"
        >
          DU CSAS 2026 Round 2: Allotment Breakdown, Revised Schedule, and Next Steps
        </a>
        .
      </p>
      <p className="text-sm text-pencil">
        If you are not redirected automatically within a few seconds, please{" "}
        <a href="/blog/du-csas-round-2-allotment-2026" className="underline">
          click here to view the updated guide
        </a>
        .
      </p>
    </div>
  );
}

